import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { TypedMemo } from '../../common/types';
import styles from './SMLPublishedActions.module.scss';

interface SMLPublishedActionsProps {
  onDone: () => void;
  onOpenPage: () => void;
}

/**
 * The way out.
 *
 * "Done" closes something that has already happened; the old "Not now"
 * declined it, which was never on offer.
 */
const SMLPublishedActionsComponent: React.FC<SMLPublishedActionsProps> = ({ onDone, onOpenPage }) => {
  const intl = useIntl();

  return (
    <div className={styles.actions}>
      <div className={styles.buttons}>
        <button type="button" className={styles.primary} onClick={onDone}>
          {intl.formatMessage({ id: 'app.sml.published.done', defaultMessage: 'Done' })}
        </button>
        <button type="button" className={styles.secondary} onClick={onOpenPage}>
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          {intl.formatMessage({ id: 'app.sml.published.open', defaultMessage: 'Open page' })}
        </button>
      </div>
      <p className={styles.fineprint}>
        <FontAwesomeIcon icon={faShieldCheck} />
        {intl.formatMessage({
          id: 'app.sml.published.fineprint',
          defaultMessage: 'Anyone with the link can open it. Edit the page or its address any time.',
        })}
      </p>
    </div>
  );
};

export const SMLPublishedActions = TypedMemo(SMLPublishedActionsComponent);
